export enum Status {
    OK = 'OK',
    KEINE_BERECHTIGUNG = 'KEINE_BERECHTIGUNG',
}
